var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18.8182V2.06023C0.500063 1.7636 0.588071 1.47365 0.752897 1.22704C0.917723 0.980425 1.15197 0.788215 1.42602 0.67471C1.70007 0.561205 2.00161 0.531501 2.29254 0.589352C2.58347 0.647204 2.85072 0.790013 3.0605 0.999727L11.4395 9.37873C11.7207 9.66002 11.8787 10.0415 11.8787 10.4392C11.8787 10.837 11.7207 11.2184 11.4395 11.4997L3.0605 19.8787C2.85072 20.0884 2.58347 20.2312 2.29254 20.2891C2.00161 20.347 1.70007 20.3172 1.42602 20.2037C1.15197 20.0902 0.917723 19.898 0.752897 19.6514C0.588071 19.4048 0.500063 19.1149 0.5 18.8182Z",
    fill: "#CCDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.1f88f277217d2338f3a3dfe532552fba.svg";
export { ForwardRef as ReactComponent };